import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../components/HomePage.vue'
import GuidePage from '../views/GuidePage.vue'
import HistoryPage from '../views/HistoryPage.vue'
import TestTypeSelectionPage from '../views/TestTypeSelectionPage.vue'
import StartAssessmentPage from '../views/StartAssessmentPage.vue'
import BasicInfoPage from '../views/BasicInfoPage.vue'
import QuestionnairePage from '../views/QuestionnairePage.vue'
import CalculatingPage from '../views/CalculatingPage.vue'

// AYP测试结果页面
import AYPResultPage from '../views/AYPResultPage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/guide',
    name: 'Guide',
    component: GuidePage
  },
  {
    path: '/history',
    name: 'History',
    component: HistoryPage
  },
  {
    path: '/assessment/select-type',
    name: 'TestTypeSelection',
    component: TestTypeSelectionPage
  },
  {
    path: '/assessment/start',
    name: 'StartAssessment',
    component: StartAssessmentPage
  },
  {
    path: '/assessment/info',
    name: 'BasicInfo',
    component: BasicInfoPage
  },
  {
    path: '/assessment/questions',
    name: 'Questionnaire',
    component: QuestionnairePage
  },
  {
    path: '/assessment/calculating',
    name: 'Calculating',
    component: CalculatingPage
  },
  // AYP测试结果页
  {
    path: '/animal-result',
    name: 'AYPResult',
    component: AYPResultPage
  },
  // AYP结果页别名
  {
    path: '/ayp-result',
    redirect: '/animal-result'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router

